import React, { useState } from "react";
import classes from "./styles.module.scss";
import TopBar from "./topBar";
import LeftBar from "./leftBar";

const Layout = (props) => {
    // Collapsed rail is remembered for the session so the choice survives
    // navigation between pages.
    const [collapsed, setCollapsed] = useState(
        () => localStorage.getItem("bor-admin-sidebar") === "collapsed"
    );
    const [mobileOpen, setMobileOpen] = useState(false);

    const toggleCollapsed = () => {
        setCollapsed((prev) => {
            localStorage.setItem("bor-admin-sidebar", !prev ? "collapsed" : "expanded");
            return !prev;
        });
    };

    return (
        <div
            className={`${classes.shell} ${collapsed ? classes.is_collapsed : ""} ${mobileOpen ? classes.is_mobile_open : ""}`}
        >
            <LeftBar
                type={props.type}
                // The drawer always shows full labels, whatever the desktop
                // rail preference happens to be.
                collapsed={collapsed && !mobileOpen}
                mobileOpen={mobileOpen}
                onNavigate={() => setMobileOpen(false)}
            />

            <div
                className={classes.scrim}
                onClick={() => setMobileOpen(false)}
                aria-hidden="true"
            />

            <div className={classes.main}>
                <TopBar
                    collapsed={collapsed}
                    onToggleSidebar={toggleCollapsed}
                    onOpenMobileNav={() => setMobileOpen(true)}
                />
                <main className={classes.content}>{props.children}</main>
            </div>
        </div>
    );
};

export default Layout;
